import { useEffect } from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  type FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';

/** Renders nothing; keeps default {} for MCP parameter_overrides slots in templates. */
const HiddenField = (
  props: FieldExtensionComponentProps<Record<string, unknown>>,
) => {
  const { onChange, formData } = props;

  useEffect(() => {
    if (formData === undefined || formData === null) {
      onChange({});
    }
  }, [formData, onChange]);

  return null;
};

export const HiddenFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'Hidden',
    component: HiddenField,
  }),
);
